(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-accessories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.tgm-acc').forEach(function (root) {
      if (root.dataset.tgmAccInit) return;
      root.dataset.tgmAccInit = '1';
      var el = root.querySelector('[data-tgm-animate]');
      if (!el) return;
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('tgm-acc--in');
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.15 });
        io.observe(el);
      } else {
        el.classList.add('tgm-acc--in');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-announcement"] && !Shopify.designMode) return;
  try {
    
  class TgmAnnouncement extends HTMLElement {
    constructor() {
      super();
      this.current = 0;
      this.timer = null;
    }

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.tgm-announcement__slide'));
      if (this.slides.length <= 1) return;

      var speed = parseInt(this.dataset.speed, 10) || 4;
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.timer = setInterval(function() {
        var prev = this.slides[this.current];
        prev.classList.remove('is-active');
        prev.classList.add('is-exiting');

        this.current = (this.current + 1) % this.slides.length;
        var next = this.slides[this.current];
        next.classList.remove('is-exiting');
        next.classList.add('is-active');

        setTimeout(function() {
          prev.classList.remove('is-exiting');
        }, prefersReducedMotion ? 0 : 600);
      }.bind(this), speed * 1000);
    }

    disconnectedCallback() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  if (!customElements.get('tgm-announcement')) {
    customElements.define('tgm-announcement', TgmAnnouncement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-bestsellers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.tgm-bs').forEach(function (root) {
      if (root.dataset.tgmBsInit) return;
      root.dataset.tgmBsInit = '1';

      var cards = root.querySelectorAll('[data-tgm-animate]');
      if (!cards.length) return;

      var revealed = false;
      function revealAll() {
        if (revealed) return;
        revealed = true;
        cards.forEach(function (c) { c.classList.add('tgm-bs--in'); });
      }

      // Safety net: if the scroll-reveal observer never fires (e.g. inside
      // the theme editor preview iframe, or any environment where
      // IntersectionObserver misbehaves), force-reveal everything so the
      // section never gets stuck looking empty.
      var safetyTimer = setTimeout(revealAll, 1500);

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('tgm-bs--in');
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
        cards.forEach(function (c) { io.observe(c); });
      } else {
        revealAll();
      }

      window.addEventListener('load', function () {
        clearTimeout(safetyTimer);
        setTimeout(revealAll, 300);
      }, { once: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  class TgmCartDrawer extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('.tgm-cart-drawer');
      if (!this.drawer) return;

      var self = this;
      var closeBtn = this.drawer.querySelector('.tgm-cart-drawer__close');
      var overlay = this.drawer.querySelector('.tgm-cart-drawer__overlay');

      var close = function() {
        self.drawer.classList.remove('is-open');
        self.drawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      };

      if (closeBtn) closeBtn.addEventListener('click', close);
      if (overlay) overlay.addEventListener('click', close);

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && self.drawer.classList.contains('is-open')) close();
      });

      document.addEventListener('cart:open', function() {
        self.refreshCart();
        self.drawer.classList.add('is-open');
        self.drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });

      document.addEventListener('cart:item-added', function() {
        self.refreshCart();
        self.drawer.classList.add('is-open');
        self.drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });

      var cartToggles = document.querySelectorAll('[data-cart-toggle], a[href="/cart"]');
      cartToggles.forEach(function(el) {
        el.addEventListener('click', function(e) {
          e.preventDefault();
          self.refreshCart();
          self.drawer.classList.add('is-open');
          self.drawer.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        });
      });

      this.querySelectorAll('[data-tgm-upsell-add]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          self.addUpsell(btn);
        });
      });
    }

    async addUpsell(btn) {
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      btn.disabled = true;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        this.refreshCart();
      } catch (err) {
        console.error('Upsell add error:', err);
      } finally {
        btn.disabled = false;
      }
    }

    async refreshCart() {
      try {
        var response = await fetch('/cart.js');
        var cart = await response.json();
        this.renderCart(cart);
      } catch (err) {
        console.error('Cart fetch error:', err);
      }
    }

    renderCart(cart) {
      var body = this.querySelector('#tgm-cart-drawer-body');
      var footer = this.querySelector('#tgm-cart-drawer-footer');
      var subtotal = this.querySelector('#tgm-cart-subtotal');

      if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML = '<div class="tgm-cart-drawer__empty"><svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" opacity="0.3"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg><p class="tgm-cart-drawer__empty-text">Your cart is empty</p><a href="/collections/all" class="tgm-cart-drawer__empty-cta">EXPLORE THE COLLECTION</a></div>';
        if (footer) footer.style.display = 'none';
        return;
      }

      var html = '';
      var self = this;
      cart.items.forEach(function(item) {
        var img = item.image ? item.image.replace(/(\\.[^.]+)$/, '_160x$1') : '';
        var variant = item.variant_title || '';
        var price = (item.final_line_price / 100).toFixed(2);

        html += '<div class="tgm-cart-drawer__item">';
        html += '<img src="' + img + '" alt="" class="tgm-cart-drawer__item-image" loading="lazy" width="80" height="80">';
        html += '<div class="tgm-cart-drawer__item-info">';
        html += '<a href="' + item.url + '" class="tgm-cart-drawer__item-name">' + item.product_title + '</a>';
        if (variant) html += '<span class="tgm-cart-drawer__item-variant">' + variant + '</span>';
        html += '<div class="tgm-cart-drawer__item-bottom">';
        html += '<div class="tgm-cart-drawer__item-qty">';
        html += '<button class="tgm-cart-drawer__qty-btn" data-key="' + item.key + '" data-action="minus" type="button" aria-label="Decrease quantity">−</button>';
        html += '<span class="tgm-cart-drawer__qty-val">' + item.quantity + '</span>';
        html += '<button class="tgm-cart-drawer__qty-btn" data-key="' + item.key + '" data-action="plus" type="button" aria-label="Increase quantity">+</button>';
        html += '</div>';
        html += '<span class="tgm-cart-drawer__item-price">' + Shopify.formatMoney(item.final_line_price) + '</span>';
        html += '</div></div></div>';
      });

      body.innerHTML = html;
      if (footer) footer.style.display = '';
      if (subtotal) subtotal.textContent = Shopify.formatMoney(cart.total_price);
      self.renderDiscountProgress(cart);

      body.querySelectorAll('.tgm-cart-drawer__qty-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          self.updateQty(btn.dataset.key, btn.dataset.action);
        });
      });
    }

    renderDiscountProgress(cart) {
      var el = this.querySelector('#tgm-cart-discount-progress');
      if (!el) return;

      var watchTypes = ['Watch', 'Chronograph', 'GMT Watch'];
      var watchQty = 0;
      cart.items.forEach(function(item) {
        if (watchTypes.indexOf(item.product_type) !== -1) watchQty += item.quantity;
      });

      if (watchQty === 1) {
        el.textContent = 'Add 1 more watch and save $30';
        el.className = 'tgm-cart-drawer__discount-progress';
        el.style.display = '';
      } else if (watchQty >= 2) {
        el.textContent = '$30 discount applied';
        el.className = 'tgm-cart-drawer__discount-progress tgm-cart-drawer__discount-progress--active';
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    }

    async updateQty(key, action) {
      try {
        var cartResp = await fetch('/cart.js');
        var cart = await cartResp.json();
        var item = cart.items.find(function(i) { return i.key === key; });
        if (!item) return;

        var newQty = action === 'plus' ? item.quantity + 1 : item.quantity - 1;
        if (newQty < 0) newQty = 0;

        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        });

        this.refreshCart();
      } catch (err) {
        console.error('Cart update error:', err);
      }
    }
  }

  if (!customElements.get('tgm-cart-drawer')) {
    customElements.define('tgm-cart-drawer', TgmCartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-collection-hero"] && !Shopify.designMode) return;
  try {
    
  class TgmCollectionHero extends HTMLElement {
    connectedCallback() {
      var reveals = Array.from(this.querySelectorAll('[data-tgm-reveal]'));
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (prefersReducedMotion) {
        reveals.forEach(function(el) { el.classList.add('is-revealed'); });
        return;
      }

      reveals.forEach(function(el) {
        var delay = parseInt(el.dataset.delay, 10) || 0;
        setTimeout(function() {
          el.classList.add('is-revealed');
        }, delay + 200);
      });
    }
  }

  if (!customElements.get('tgm-collection-hero')) {
    customElements.define('tgm-collection-hero', TgmCollectionHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-collection-tabs"] && !Shopify.designMode) return;
  try {
    
class TGMCollectionTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll('[data-tab-index]');
    this.panels = this.querySelectorAll('[data-tab-panel]');

    for (const tab of this.tabs) {
      tab.addEventListener('click', () => this.#switchTab(tab));
    }

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.classList.add('is-visible');
            observer.disconnect();
          }
        }
      },
      { threshold: 0.15 }
    );
    observer.observe(this);
  }

  #switchTab(activeTab) {
    const index = activeTab.dataset.tabIndex;

    for (const tab of this.tabs) {
      const isActive = tab.dataset.tabIndex === index;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    }

    for (const panel of this.panels) {
      const isActive = panel.dataset.tabPanel === index;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    }
  }
}

customElements.define('tgm-collection-tabs', TGMCollectionTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-collections-showcase"] && !Shopify.designMode) return;
  try {
    
  class TGMCoverflow extends HTMLElement {
    constructor() { super(); this.idx = 0; this.timer = null; }
    connectedCallback() {
      this.track = this.querySelector('.tgm-collections-showcase__track');
      this.slides = [...this.querySelectorAll('.tgm-collections-showcase__slide')];
      this.prev = this.querySelector('.tgm-collections-showcase__arrow--prev');
      this.next = this.querySelector('.tgm-collections-showcase__arrow--next');
      this.dotsWrap = this.querySelector('.tgm-collections-showcase__dots');
      if (!this.slides.length) return;
      this.slides.forEach(function(_, i) { var d = document.createElement('button'); d.className = 'tgm-collections-showcase__dot'; d.setAttribute('aria-label', 'Slide ' + (i+1)); d.addEventListener('click', this.go.bind(this, i)); this.dotsWrap.appendChild(d); }.bind(this));
      this.dots = [...this.dotsWrap.querySelectorAll('.tgm-collections-showcase__dot')];
      this.prev.addEventListener('click', this.move.bind(this, -1));
      this.next.addEventListener('click', this.move.bind(this, 1));
      this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
      this.addEventListener('mouseenter', this.stop.bind(this));
      this.addEventListener('mouseleave', this.start.bind(this));
      this.update(); if (this.dataset.autoplay === 'true') this.start();
    }
    go(i) { this.idx = Math.max(0, Math.min(i, this.slides.length - 1)); var s = this.slides[this.idx]; var t = this.track; var o = s.offsetLeft - t.offsetLeft - (t.offsetWidth - s.offsetWidth) / 2; t.scrollTo({ left: o, behavior: 'smooth' }); this.update(); }
    move(d) { this.go(this.idx + d < 0 ? this.slides.length - 1 : this.idx + d >= this.slides.length ? 0 : this.idx + d); }
    onScroll() { if (this._drag) return; var t = this.track; var c = t.scrollLeft + t.offsetWidth / 2; var best = 0, min = Infinity; this.slides.forEach(function(s, i) { var d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - c); if (d < min) { min = d; best = i; } }); this.idx = best; this.update(); }
    update() { this.slides.forEach(function(s, i) { s.classList.toggle('is-active', i === this.idx); }.bind(this)); if (this.dots) this.dots.forEach(function(d, i) { d.classList.toggle('is-active', i === this.idx); }.bind(this)); }
    start() { this.stop(); var sp = parseInt(this.dataset.speed, 10) || 5000; this.timer = setInterval(this.move.bind(this, 1), sp); }
    stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
    disconnectedCallback() { this.stop(); }
  }
  if (!customElements.get('tgm-coverflow')) customElements.define('tgm-coverflow', TGMCoverflow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-comparison"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.tgm-cmp').forEach(function (root) {
      if (root.dataset.tgmCmpInit) return;
      root.dataset.tgmCmpInit = '1';
      var el = root.querySelector('[data-tgm-animate]');
      if (!el) return;
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('tgm-cmp--in');
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.15 });
        io.observe(el);
      } else {
        el.classList.add('tgm-cmp--in');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-configurator-preview"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-tgm-cfg-root]').forEach(function (root) {
      if (root.dataset.tgmCfgInit) return;
      root.dataset.tgmCfgInit = '1';

      var content = root.querySelector('[data-tgm-animate]');
      var revealed = false;
      function reveal() {
        if (revealed || !content) return;
        revealed = true;
        content.classList.add('tgm-cfg--in');
      }
      var safetyTimer = setTimeout(reveal, 1200);

      if (content && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              reveal();
              io.disconnect();
            }
          });
        }, { threshold: 0.15 });
        io.observe(content);
      } else {
        reveal();
      }

      window.addEventListener('load', function () {
        clearTimeout(safetyTimer);
        setTimeout(reveal, 200);
      }, { once: true });

      // 3D tilt on pointer devices only (touch devices never fire mousemove).
      var tiltWrap = root.querySelector('[data-tgm-cfg-tilt]');
      var media = tiltWrap ? tiltWrap.querySelector('.tgm-cfg__media') : null;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      if (tiltWrap && media && canHover && !reduceMotion) {
        var raf = null;
        tiltWrap.addEventListener('mousemove', function (e) {
          var rect = tiltWrap.getBoundingClientRect();
          var px = (e.clientX - rect.left) / rect.width;
          var py = (e.clientY - rect.top) / rect.height;
          var ry = (px - 0.5) * 14;
          var rx = (0.5 - py) * 14;
          if (raf) cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () {
            media.style.setProperty('--tgm-rx', rx.toFixed(2) + 'deg');
            media.style.setProperty('--tgm-ry', ry.toFixed(2) + 'deg');
          });
        });
        tiltWrap.addEventListener('mouseleave', function () {
          if (raf) cancelAnimationFrame(raf);
          media.style.setProperty('--tgm-rx', '0deg');
          media.style.setProperty('--tgm-ry', '0deg');
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-customers-worldwide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tgm-worldwide')) {
    class TgmWorldwide extends HTMLElement {
      constructor() {
        super();
        this._observer = null;
      }

      connectedCallback() {
        var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (prefersReduced) {
          this.querySelectorAll('[data-reveal]').forEach(function (el) {
            el.classList.add('is-visible');
          });
          return;
        }

        if (!('IntersectionObserver' in window)) {
          this.querySelectorAll('[data-reveal]').forEach(function (el) {
            el.classList.add('is-visible');
          });
          return;
        }

        this._observer = new IntersectionObserver(
          function (entries, observer) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
        );

        this.querySelectorAll('[data-reveal]').forEach(
          function (el) {
            this._observer.observe(el);
          }.bind(this)
        );
      }

      disconnectedCallback() {
        if (this._observer) {
          this._observer.disconnect();
          this._observer = null;
        }
      }
    }

    customElements.define('tgm-worldwide', TgmWorldwide);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-guarantee-compact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.tgm-gtc').forEach(function (root) {
      if (root.dataset.tgmGtcInit) return;
      root.dataset.tgmGtcInit = '1';
      var items = root.querySelectorAll('[data-tgm-animate]');
      if ('IntersectionObserver' in window && items.length) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('tgm-gtc--in');
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.15 });
        items.forEach(function (i) { io.observe(i); });
      } else {
        items.forEach(function (i) { i.classList.add('tgm-gtc--in'); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-header"] && !Shopify.designMode) return;
  try {
    
  class TgmHeader extends HTMLElement {
    connectedCallback() {
      var header = this.querySelector('[data-tgm-header]');
      var spacer = this.querySelector('[data-tgm-header-spacer]');
      var menuToggle = this.querySelector('[data-tgm-menu-toggle]');
      var menuClose = this.querySelector('[data-tgm-menu-close]');
      var overlay = this.querySelector('[data-tgm-overlay]');
      var mobileMenu = this.querySelector('[data-tgm-mobile-menu]');
      var cartToggle = this.querySelector('[data-tgm-cart-toggle]');
      var cartCount = this.querySelector('[data-cart-count]');

      var isHome = this.dataset.home === 'true';

      var ann = document.querySelector('.tgm-announcement');
      var annHeight = ann ? ann.offsetHeight : 0;

      header.style.top = annHeight + 'px';

      function updateSpacer() {
        if (!spacer) return;
        var transparentNow = isHome && !header.classList.contains('is-solid');
        spacer.style.height = transparentNow ? '0px' : header.offsetHeight + 'px';
      }

      function onScroll() {
        var pastAnnouncement = window.scrollY > annHeight;

        if (isHome) {
          if (pastAnnouncement) {
            header.classList.add('is-solid', 'is-stuck');
          } else {
            header.classList.remove('is-solid', 'is-stuck');
            header.style.top = Math.max(0, annHeight - window.scrollY) + 'px';
          }
        } else {
          header.classList.add('is-solid');
          if (pastAnnouncement) {
            header.classList.add('is-stuck');
          } else {
            header.classList.remove('is-stuck');
            header.style.top = Math.max(0, annHeight - window.scrollY) + 'px';
          }
        }

        updateSpacer();
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      if (window.ResizeObserver) {
        new ResizeObserver(updateSpacer).observe(header);
      } else {
        window.addEventListener('resize', updateSpacer);
      }
      window.addEventListener('load', updateSpacer);

      function openMenu() {
        mobileMenu.classList.add('is-open');
        overlay.classList.add('is-open');
        mobileMenu.setAttribute('aria-hidden', 'false');
        mobileMenu.removeAttribute('inert');
        menuToggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      }

      function closeMenu() {
        mobileMenu.classList.remove('is-open');
        overlay.classList.remove('is-open');
        mobileMenu.setAttribute('aria-hidden', 'true');
        mobileMenu.setAttribute('inert', '');
        menuToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }

      if (menuToggle) menuToggle.addEventListener('click', openMenu);
      if (menuClose) menuClose.addEventListener('click', closeMenu);
      if (overlay) overlay.addEventListener('click', closeMenu);

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
          closeMenu();
        }
      });

      if (cartToggle) {
        cartToggle.addEventListener('click', function(e) {
          e.preventDefault();
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          } else {
            window.location.href = '/cart';
          }
        });
      }

      function updateCartCount() {
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            // Cart rewards (03-10-2026): free gift lines (_tgm_gift) are not counted as items.
            var count = (cart.items || []).reduce(function(n, i) { return n + (i.properties && i.properties._tgm_gift ? 0 : i.quantity); }, 0);
            if (cartCount) {
              if (count > 0) {
                cartCount.textContent = count;
                cartCount.style.display = '';
              } else {
                cartCount.style.display = 'none';
              }
            }
          })
          .catch(function() {});
      }

      updateCartCount();
      document.addEventListener('cart:item-added', updateCartCount);
      document.addEventListener('cart:updated', updateCartCount);
      // The theme cart (drawer and page) publishes cartUpdate through its pub/sub helper and fires
      // cartQuantityUpdated; listen to both so the badge updates without a page reload.
      document.addEventListener('cartQuantityUpdated', updateCartCount);
      // PUB_SUB_EVENTS is a top-level const (not a window property), so check the binding itself.
      function hookCartPubSub() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) return false;
        subscribe(PUB_SUB_EVENTS.cartUpdate, function() { setTimeout(updateCartCount, 150); });
        return true;
      }
      if (!hookCartPubSub()) {
        document.addEventListener('DOMContentLoaded', hookCartPubSub, { once: true });
      }

      // Keep aria-expanded in sync with the CSS hover/focus dropdowns.
      this.querySelectorAll('[data-tgm-dropdown]').forEach(function(dropdown) {
        var trigger = dropdown.querySelector('[aria-expanded]');
        if (!trigger) return;
        var setOpen = function(open) { trigger.setAttribute('aria-expanded', open ? 'true' : 'false'); };
        dropdown.addEventListener('mouseenter', function() { setOpen(true); });
        dropdown.addEventListener('mouseleave', function() { setOpen(dropdown.contains(document.activeElement)); });
        dropdown.addEventListener('focusin', function() { setOpen(true); });
        dropdown.addEventListener('focusout', function(event) { if (!dropdown.contains(event.relatedTarget)) setOpen(false); });
      });
    }
  }

  if (!customElements.get('tgm-header')) {
    customElements.define('tgm-header', TgmHeader);
  }

  // Language and currency selector: native <details> toggle, closed by Escape or an outside click.
  if (!window.tgmLocBound) {
    window.tgmLocBound = true;
    document.addEventListener('click', function (event) {
      var all = document.querySelectorAll('[data-tgm-loc][open]');
      for (var i = 0; i < all.length; i++) {
        if (!all[i].contains(event.target)) all[i].removeAttribute('open');
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var all = document.querySelectorAll('[data-tgm-loc][open]');
      for (var i = 0; i < all.length; i++) {
        all[i].removeAttribute('open');
        var toggle = all[i].querySelector('summary');
        if (toggle && all[i].contains(document.activeElement)) toggle.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-hero"] && !Shopify.designMode) return;
  try {
    
class TGMHero extends HTMLElement {
  connectedCallback() {
    this.contentInner = this.querySelector('[data-hero-animate]');
    this.parallaxImage = this.querySelector('[data-parallax] .tgm-hero__img');

    requestAnimationFrame(() => {
      if (this.contentInner) {
        this.contentInner.classList.add('is-visible');
      }
    });

    const desktop = window.matchMedia('(min-width: 750px)').matches;
    if (this.parallaxImage && desktop && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.#initParallax();
    }
  }

  #initParallax() {
    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(() => {
          const rect = this.getBoundingClientRect();
          const viewH = window.innerHeight;
          if (rect.bottom > 0 && rect.top < viewH) {
            const progress = (viewH - rect.top) / (viewH + rect.height);
            const y = (progress - 0.5) * 40;
            this.parallaxImage.style.transform = `translateY(${y}px) scale(1.05)`;
          }
          ticking = false;
        });
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
}

if (!customElements.get('tgm-hero')) customElements.define('tgm-hero', TGMHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-instagram"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.tgm-ig').forEach(function (root) {
      if (root.dataset.tgmIgInit) return;
      root.dataset.tgmIgInit = '1';
      var els = root.querySelectorAll('[data-tgm-animate]');
      if ('IntersectionObserver' in window && els.length) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('tgm-ig--in');
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.1 });
        els.forEach(function (e) { io.observe(e); });
      } else {
        els.forEach(function (e) { e.classList.add('tgm-ig--in'); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-ladies-watches"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.tgm-lb').forEach(function (root) {
      if (root.dataset.tgmLbInit) return;
      root.dataset.tgmLbInit = '1';
      var el = root.querySelector('[data-tgm-animate]');
      if (!el) return;
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('tgm-lb--in');
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.15 });
        io.observe(el);
      } else {
        el.classList.add('tgm-lb--in');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-pdp-craftsmanship"] && !Shopify.designMode) return;
  try {
    
(function() {
  var wrappers = document.querySelectorAll('[data-parallax]');
  if (!wrappers.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function onScroll() {
    wrappers.forEach(function(wrapper) {
      var rate = parseFloat(wrapper.getAttribute('data-parallax')) || 0.1;
      var rect = wrapper.getBoundingClientRect();
      var viewH = window.innerHeight;
      if (rect.bottom < 0 || rect.top > viewH) return;
      var offset = (rect.top - viewH / 2) * rate;
      var img = wrapper.querySelector('img, svg');
      if (img) {
        img.style.transform = 'translateY(' + offset + 'px) scale(1.05)';
      }
    });
  }

  var ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(function() {
        onScroll();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  onScroll();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-pdp-related"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* Async-load product recommendations if the section is on a product page */
  var section = document.querySelector('[data-section-id].tgm-related, .tgm-section-related');
  if (!section) return;

  var placeholder = section.querySelector('.tgm-related__item--placeholder');
  if (!placeholder) return;

  var productId = null;
  var metaTag = document.querySelector('meta[property="og:type"][content="product"]');
  if (metaTag) {
    var idMeta = document.querySelector('[data-product-id]');
    if (idMeta) {
      productId = idMeta.getAttribute('data-product-id');
    }
  }

  if (!productId) return;

  var sectionId = section.getAttribute('data-section-id');
  var url = '/recommendations/products?product_id=' + productId + '&limit=4&section_id=' + sectionId;

  fetch(url)
    .then(function(response) { return response.text(); })
    .then(function(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var newContent = doc.querySelector('.tgm-related__carousel');
      if (newContent) {
        var carousel = section.querySelector('.tgm-related__carousel');
        if (carousel) {
          carousel.innerHTML = newContent.innerHTML;
        }
      }
    })
    .catch(function() {
      /* Fail silently — placeholders remain */
    });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-pdp-reviews"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('[data-reviews-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var sectionId = this.getAttribute('data-reviews-toggle');
      var grid = document.getElementById('tgm-reviews-grid-' + sectionId);
      if (!grid) return;

      var hidden = grid.querySelectorAll('.tgm-reviews__card--hidden');
      var expanded = this.getAttribute('aria-expanded') === 'true';

      if (!expanded) {
        hidden.forEach(function(card) {
          card.classList.add('tgm-reviews__card--visible');
        });
        this.textContent = 'Show Less';
        this.setAttribute('aria-expanded', 'true');
      } else {
        hidden.forEach(function(card) {
          card.classList.remove('tgm-reviews__card--visible');
        });
        this.textContent = 'Show More Reviews';
        this.setAttribute('aria-expanded', 'false');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-popup-newsletter"] && !Shopify.designMode) return;
  try {
    
  class TgmPopupNewsletter extends HTMLElement {
    connectedCallback() {
      if (sessionStorage.getItem('tgm-popup-closed')) return;

      this.popup = this.querySelector('.tgm-popup');
      if (!this.popup) return;

      var closeBtn = this.popup.querySelector('.tgm-popup__close');
      var overlay = this.popup.querySelector('.tgm-popup__overlay');
      var self = this;

      var close = function() {
        self.popup.classList.remove('is-open');
        self.popup.setAttribute('aria-hidden', 'true');
        sessionStorage.setItem('tgm-popup-closed', '1');
        document.body.style.overflow = '';
      };

      if (closeBtn) closeBtn.addEventListener('click', close);
      if (overlay) overlay.addEventListener('click', close);

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && self.popup.classList.contains('is-open')) close();
      });

      var open = function() {
        if (sessionStorage.getItem('tgm-popup-closed')) return;
        self.popup.classList.add('is-open');
        self.popup.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      };

      var delay = parseInt(this.dataset.delay, 10) || 6;
      setTimeout(open, delay * 1000);

      if (this.dataset.exitIntent === 'true') {
        document.addEventListener('mouseout', function handler(e) {
          if (e.clientY < 5 && !sessionStorage.getItem('tgm-popup-closed')) {
            open();
            document.removeEventListener('mouseout', handler);
          }
        });
      }

      var form = this.querySelector('form');
      if (form) {
        form.addEventListener('submit', function() {
          setTimeout(close, 2000);
        });
      }
    }
  }

  if (!customElements.get('tgm-popup-newsletter')) {
    customElements.define('tgm-popup-newsletter', TgmPopupNewsletter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-product-engraving"] && !Shopify.designMode) return;
  try {
    
  class TgmEngraving extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-engraving-toggle]');
      this.body = this.querySelector('[data-engraving-body]');
      this.input = this.querySelector('[data-engraving-input]');
      this.count = this.querySelector('[data-engraving-count]');

      if (!this.toggle || !this.body || !this.input) return;

      var self = this;
      var maxLen = parseInt(this.input.getAttribute('maxlength'), 10) || 20;

      this.toggle.addEventListener('change', function() {
        if (self.toggle.checked) {
          self.body.style.display = '';
          self.input.disabled = false;
          self.input.focus();
        } else {
          self.body.style.display = 'none';
          self.input.disabled = true;
          self.input.value = '';
          if (self.count) self.count.textContent = '0/' + maxLen;
        }
      });

      this.input.addEventListener('input', function() {
        if (self.count) {
          self.count.textContent = self.input.value.length + '/' + maxLen;
        }
      });
    }
  }

  if (!customElements.get('tgm-engraving')) {
    customElements.define('tgm-engraving', TgmEngraving);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-product-reviews"] && !Shopify.designMode) return;
  try {
    
  class TgmProductReviews extends HTMLElement {
    connectedCallback() {
      var items = Array.from(this.querySelectorAll('[data-tgm-reveal]'));
      if (!items.length) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        items.forEach(function(el) { el.classList.add('is-revealed'); });
        return;
      }

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });

      items.forEach(function(el) { observer.observe(el); });
    }
  }

  if (!customElements.get('tgm-product-reviews')) {
    customElements.define('tgm-product-reviews', TgmProductReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
class TgmReviewsCarousel extends HTMLElement {
  constructor() {
    super();
    this.track = null;
    this.cards = [];
    this.dots = [];
    this.currentIndex = 0;
    this.autoplayTimer = null;
    this.isAutoplay = false;
    this.speed = 5000;
  }

  connectedCallback() {
    this.track = this.querySelector('.tgm-reviews-carousel__track');
    this.cards = Array.from(this.querySelectorAll('.tgm-reviews-carousel__card'));
    this.dots = Array.from(this.querySelectorAll('.tgm-reviews-carousel__dot'));

    if (!this.track || this.cards.length === 0) return;

    this.speed = parseInt(this.dataset.speed, 10) || 5000;
    this.isAutoplay = this.hasAttribute('data-autoplay');

    const prevBtn = this.querySelector('.tgm-reviews-carousel__arrow--prev');
    const nextBtn = this.querySelector('.tgm-reviews-carousel__arrow--next');

    if (prevBtn) prevBtn.addEventListener('click', () => this.prev());
    if (nextBtn) nextBtn.addEventListener('click', () => this.next());

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const idx = parseInt(dot.dataset.index, 10);
        this.goTo(idx);
      });
    });

    this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });

    // Pause autoplay on hover or focus
    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => {
      if (this.isAutoplay) this.startAutoplay();
    });
    this.addEventListener('focusin', () => this.stopAutoplay());
    this.addEventListener('focusout', (e) => {
      if (!this.contains(e.relatedTarget) && this.isAutoplay) this.startAutoplay();
    });

    // Reduced motion check
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (prefersReducedMotion.matches) {
      this.isAutoplay = false;
    }
    prefersReducedMotion.addEventListener('change', (e) => {
      if (e.matches) {
        this.isAutoplay = false;
        this.stopAutoplay();
      }
    });

    if (this.isAutoplay) this.startAutoplay();
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }

  getCardWidth() {
    if (this.cards.length === 0) return 0;
    const card = this.cards[0];
    const style = window.getComputedStyle(this.track);
    const gap = parseInt(style.gap, 10) || 24;
    return card.offsetWidth + gap;
  }

  goTo(index) {
    if (index < 0) index = 0;
    if (index >= this.cards.length) index = 0;
    this.currentIndex = index;
    const offset = this.getCardWidth() * index;
    this.track.scrollTo({ left: offset, behavior: 'smooth' });
    this.updateDots();
  }

  prev() {
    this.goTo(this.currentIndex - 1 < 0 ? this.cards.length - 1 : this.currentIndex - 1);
  }

  next() {
    this.goTo(this.currentIndex + 1);
  }

  onScroll() {
    const cardWidth = this.getCardWidth();
    if (cardWidth === 0) return;
    const newIndex = Math.round(this.track.scrollLeft / cardWidth);
    if (newIndex !== this.currentIndex) {
      this.currentIndex = newIndex;
      this.updateDots();
    }
  }

  updateDots() {
    this.dots.forEach((dot, i) => {
      const isActive = i === this.currentIndex;
      dot.classList.toggle('tgm-reviews-carousel__dot--active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  startAutoplay() {
    this.stopAutoplay();
    this.autoplayTimer = setInterval(() => this.next(), this.speed);
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }
}

if (!customElements.get('tgm-reviews-carousel')) {
  customElements.define('tgm-reviews-carousel', TgmReviewsCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-reviews-dark"] && !Shopify.designMode) return;
  try {
    
  class TgmReviewsDark extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
    }

    connectedCallback() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.dataset.paused = !entry.isIntersecting;
          });
        },
        { threshold: 0.1 }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }

  if (!customElements.get('tgm-reviews-dark')) {
    customElements.define('tgm-reviews-dark', TgmReviewsDark);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-reviews-wall"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('tgm-reviews-wall')) return;

    var SORTERS = {
      photos: function (a, b) {
        return (+b.dataset.photo - +a.dataset.photo) || (Date.parse(b.dataset.date) - Date.parse(a.dataset.date));
      },
      recent: function (a, b) {
        return Date.parse(b.dataset.date) - Date.parse(a.dataset.date);
      },
      rating: function (a, b) {
        return (+b.dataset.rating - +a.dataset.rating) || (Date.parse(b.dataset.date) - Date.parse(a.dataset.date));
      }
    };

    customElements.define(
      'tgm-reviews-wall',
      class extends HTMLElement {
        connectedCallback() {
          this.grid = this.querySelector('[data-tgm-rw-grid]');
          if (!this.grid) return;
          this.cards = Array.prototype.slice.call(this.grid.querySelectorAll('[data-tgm-rw-card]'));
          this.visible = parseInt(this.dataset.initial, 10) || 8;
          this.step = parseInt(this.dataset.step, 10) || 8;
          this.loadButton = this.querySelector('[data-tgm-rw-load]');
          this.sortSelect = this.querySelector('[data-tgm-rw-sort]');

          this.relativeDates();
          this.sort(this.dataset.defaultSort || 'photos');

          var self = this;
          if (this.sortSelect) {
            this.sortSelect.addEventListener('change', function () {
              self.sort(self.sortSelect.value);
            });
          }
          if (this.loadButton) {
            this.loadButton.addEventListener('click', function () {
              var firstNew = self.visible;
              self.visible += self.step;
              self.applyVisibility();
              var target = self.cards[firstNew];
              if (target) {
                target.setAttribute('tabindex', '-1');
                target.focus({ preventScroll: false });
              }
            });
          }
          this.grid.addEventListener('click', function (event) {
            var button = event.target.closest('[data-tgm-rw-more]');
            if (!button) return;
            var card = button.closest('[data-tgm-rw-card]');
            var expanded = card.classList.toggle('is-expanded');
            button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            button.textContent = expanded ? self.dataset.labelLess : self.dataset.labelMore;
            self.layout();
            if (expanded && window.TGM && window.TGM.track) {
              window.TGM.track('review_expand', { rating: +card.dataset.rating, has_photo: card.dataset.photo === '1' });
            }
          });

          if ('ResizeObserver' in window) {
            this._resizeObserver = new ResizeObserver(function () {
              self.scheduleLayout();
            });
            this._resizeObserver.observe(this.grid);
          }
          this.grid.classList.add('is-masonry');
          this.scheduleLayout();
        }

        disconnectedCallback() {
          if (this._resizeObserver) this._resizeObserver.disconnect();
        }

        relativeDates() {
          if (!('RelativeTimeFormat' in Intl)) return;
          var rtf;
          try {
            rtf = new Intl.RelativeTimeFormat(this.dataset.locale || 'en', { numeric: 'auto' });
          } catch (error) {
            rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
          }
          var now = Date.now();
          this.querySelectorAll('[data-tgm-rw-date]').forEach(function (el) {
            var then = Date.parse(el.getAttribute('datetime'));
            if (isNaN(then)) return;
            var days = Math.round((then - now) / 86400000);
            var text;
            if (Math.abs(days) < 7) text = rtf.format(days, 'day');
            else if (Math.abs(days) < 30) text = rtf.format(Math.round(days / 7), 'week');
            else if (Math.abs(days) < 365) text = rtf.format(Math.round(days / 30), 'month');
            else text = rtf.format(Math.round(days / 365), 'year');
            el.textContent = text;
          });
        }

        sort(key) {
          var sorter = SORTERS[key] || SORTERS.photos;
          this.cards.sort(sorter);
          var fragment = document.createDocumentFragment();
          this.cards.forEach(function (card) {
            fragment.appendChild(card);
          });
          this.grid.appendChild(fragment);
          this.applyVisibility();
        }

        applyVisibility() {
          var visible = this.visible;
          this.cards.forEach(function (card, index) {
            card.hidden = index >= visible;
          });
          if (this.loadButton) this.loadButton.hidden = visible >= this.cards.length;
          this.checkOverflow();
          this.layout();
        }

        checkOverflow() {
          this.cards.forEach(function (card) {
            if (card.hidden || card.classList.contains('is-expanded')) return;
            var text = card.querySelector('[data-tgm-rw-text]');
            var button = card.querySelector('[data-tgm-rw-more]');
            if (!text || !button) return;
            button.hidden = text.scrollHeight <= text.clientHeight + 1;
          });
        }

        scheduleLayout() {
          if (this._raf) cancelAnimationFrame(this._raf);
          var self = this;
          this._raf = requestAnimationFrame(function () {
            self.checkOverflow();
            self.layout();
          });
        }

        /* CSS grid masonry: each card spans as many 4px rows as its height needs. DOM order is kept. */
        layout() {
          if (!this.grid.classList.contains('is-masonry')) return;
          var gap = parseFloat(getComputedStyle(this.grid).columnGap) || 0;
          this.cards.forEach(function (card) {
            if (card.hidden) return;
            card.style.gridRowEnd = 'auto';
            var height = card.getBoundingClientRect().height;
            card.style.gridRowEnd = 'span ' + Math.ceil((height + gap) / 4);
          });
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-story-split"] && !Shopify.designMode) return;
  try {
    
  class TgmStorySplit extends HTMLElement {
    connectedCallback() {
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var reveals = Array.from(this.querySelectorAll('[data-tgm-reveal]'));
      if (prefersReducedMotion) {
        reveals.forEach(function(el) { el.classList.add('is-revealed'); });
      } else if (reveals.length > 0) {
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              var delay = parseInt(entry.target.dataset.delay, 10) || 0;
              setTimeout(function() { entry.target.classList.add('is-revealed'); }, delay);
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.2 });
        reveals.forEach(function(el) { observer.observe(el); });
      }

      if (prefersReducedMotion) return;

      var img = this.querySelector('[data-parallax]');
      if (!img) return;
      var col = img.closest('.tgm-story-split__image-col');
      if (!col) return;
      var factor = parseFloat(img.dataset.parallax) || 0.15;

      var ticking = false;
      var update = function() {
        ticking = false;
        var rect = col.getBoundingClientRect();
        var viewH = window.innerHeight;
        if (rect.bottom < 0 || rect.top > viewH) return;
        var progress = (viewH - rect.top) / (viewH + rect.height);
        var offset = (progress - 0.5) * factor * 100;
        img.style.transform = 'translateY(' + offset + '%)';
      };
      var onScroll = function() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  if (!customElements.get('tgm-story-split')) {
    customElements.define('tgm-story-split', TgmStorySplit);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-trust-bar"] && !Shopify.designMode) return;
  try {
    
  class TgmTrustBar extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-tgm-reveal]'));
      if (this.items.length === 0) return;

      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReducedMotion) {
        this.items.forEach(function(item) { item.classList.add('is-revealed'); });
        return;
      }

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var delay = parseInt(entry.target.dataset.delay, 10) || 0;
            setTimeout(function() {
              entry.target.classList.add('is-revealed');
            }, delay);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });

      this.items.forEach(function(item) { observer.observe(item); });
    }
  }

  if (!customElements.get('tgm-trust-bar')) {
    customElements.define('tgm-trust-bar', TgmTrustBar);
  }

  } catch(e) { console.error(e); }
})();
})();
